import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      gcTime: 1000 * 60 * 2,
      staleTime: 1000 * 60 * 1,
      refetchOnWindowFocus: false,
      retry: 2,
    },
  },
});
